import { pluginRegistry } from "@flow/frontend/member/plugin_api";
import { html_action_type, redirect_action_type } from "../../common/action_types";
import { HtmlActionComponent } from "./HtmlActionComponent";

pluginRegistry.registerActionComponent(html_action_type, (props) => {
  return <HtmlActionComponent {...props} />;
});

pluginRegistry.registerActionComponent(redirect_action_type, (props) => {
  const insecure_redirect = props.ctx.actionData.redirect_url;
  // use a redirect_url passed in through the URL hash if present,
  // (http://flow.example.com/act/my-action#redirect_url=http://whatever.com/foo)
  // otherwise use the configured redirect
  if (insecure_redirect) {
    // But only use it if it matches allowed prefixes!!
    const permitted = props.custom.permitted_insecure_redirect_url_prefixes.some(
      (prefix) => insecure_redirect.slice(0, prefix.length) === prefix
    );

    if (permitted) {
      window.location = insecure_redirect;
      return null;
    } else {
      return <div>Redirect URL not permitted</div>;
    }
  } else {
    window.location = props.custom.redirectUrl as any;
    return null;
  }
});
